import Crud from '../components/Branch/Crud'

let routes = {
    path: '/branches',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/branches/:operation?/:id?',
          name: 'Unidades',
          component: Crud
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/branch.js